var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-text-editor',{attrs:{"textKey":"pvp_rewards","title":"PvP Rewards","viewPermission":"PvpRewardsView","editPermission":"PvpRewardsEdit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }